import { competitorData } from '@/mocks/competitors';

export default function CompetitorSection() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 lg:px-16 bg-foreground-900">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-10">
          {/* Left: Trust Badge Image */}
          <div className="lg:col-span-2 flex items-center justify-center">
            <div className="relative w-full max-w-sm">
              <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-foreground-800">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20trust%20and%20verification%20concept%20photography%20with%20organized%20documents%20verified%20badge%20and%20certification%20symbols%20on%20warm%20dark%20charcoal%20surface%20with%20subtle%20golden%20ochre%20accents%20soft%20directional%20lighting%20creating%20sophisticated%20atmosphere%20clean%20editorial%20european%20premium%20aesthetic%20professional%20composition%20conveying%20reliability%20and%20authority&width=500&height=700&seq=trust-hoobuy-v2-01&orientation=portrait"
                  alt="HoobuySpreadsheet confiabilidade"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:col-span-3">
            <div className="text-accent-400/30 text-6xl md:text-8xl font-heading leading-none mb-2">
              &ldquo;
            </div>

            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-background-50 mb-4">
              HoobuySpreadsheet vs Concorrentes
            </h2>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-6 max-w-lg">
              Nosso sistema de <strong className="text-background-50">hoobuyspreadsheet</strong> é
              constantemente atualizado e verificado manualmente. Comparamos com as principais
              alternativas do mercado para você entender por que somos a melhor escolha em 2026.
            </p>

            {/* Competitor Table */}
            <div className="overflow-x-auto rounded-lg border border-background-50/10 mb-6">
              <table className="w-full text-xs md:text-sm">
                <thead>
                  <tr className="bg-background-50/5 text-left">
                    <th className="px-4 py-3 font-medium text-background-50/80 whitespace-nowrap">Plataforma</th>
                    <th className="px-4 py-3 font-medium text-background-50/80 whitespace-nowrap">Velocidade</th>
                    <th className="px-4 py-3 font-medium text-background-50/80 whitespace-nowrap">Organização</th>
                    <th className="px-4 py-3 font-medium text-background-50/80 whitespace-nowrap">Segurança</th>
                    <th className="px-4 py-3 font-medium text-background-50/80 whitespace-nowrap">Atualização</th>
                  </tr>
                </thead>
                <tbody>
                  {competitorData.map((row, i) => (
                    <tr
                      key={row.platform}
                      className={`${i === 0 ? 'bg-accent-500/10' : 'bg-transparent'} border-t border-background-50/5`}
                    >
                      <td className={`px-4 py-3 font-medium whitespace-nowrap ${i === 0 ? 'text-accent-400' : 'text-background-50/70'}`}>
                        {row.platform}
                      </td>
                      <td className="px-4 py-3 text-background-50/70 whitespace-nowrap">{row.velocidade}</td>
                      <td className="px-4 py-3 text-background-50/70 whitespace-nowrap">{row.organizacao}</td>
                      <td className="px-4 py-3 text-background-50/70 whitespace-nowrap">{row.seguranca}</td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        <span className={`${i === 0 ? 'text-accent-400 font-medium' : 'text-background-50/70'}`}>
                          {row.atualizacao}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Trust statement */}
            <div className="space-y-2 text-xs md:text-sm text-background-50/60">
              <p>• Não vendemos produtos — apenas curadoria de links verificados</p>
              <p>• Transparência total em todas as nossas recomendações</p>
              <p>• Uso responsável de informações de compras internacionais</p>
            </div>

            <div className="mt-5 text-xs md:text-sm text-background-50/40 font-heading italic">
              — Equipe hoobuy.beauty
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}